<template>
  <div id="NewProjectPreview">
    <!-- Header -->
    <v-img
      :aspect-ratio="screenWidthXS || screenWidthSM ? 35/9 : 45/9"
      :src="projectBackgroundPreview"
      style="overflow:initial;"
    ></v-img>

    <!-- Content -->
    <v-container>
      <v-layout row wrap justify-space-around>
        <!-- Carousel -->
        <v-flex xs12 order-xs2 sm6 oder-sm1 md7 lg8 xl9 class="my-3">
          <v-carousel :cycle="false">
            <v-carousel-item v-html="videoFrame" v-if="videoFrame"></v-carousel-item>
            <v-carousel-item v-for="(image,idx) in projectImagesPreview" :key="idx" :src="image"></v-carousel-item>
          </v-carousel>
        </v-flex>
        <!-- Card / Visit Button -->
        <v-flex xs10 order-xs1 sm5 order-sm2 md4 lg3 xl2 class="my-3">
          <v-layout row wrap fill-height align-content-space-around>
            <!-- Card -->
            <v-flex xs12>
              <v-card>
                <v-card-text primary-title class="pb-0">
                  <!-- ONG Profile Avatar -->
                  <v-btn
                    color="transparent"
                    flat
                    dark
                    small
                    absolute
                    top
                    right
                    fab
                    :style="{ 
                      height: avatar.size + 'px', 
                      width:  avatar.size + 'px',
                      top: '-' + avatar.top + 'rem' 
                    }"
                    @click="ongProfileModal = true"
                  >
                    <v-avatar :size="avatar.size">
                      <img
                        v-if="subdata.activeuser[0].img_url"
                        :src="subdata.activeuser[0].img_url"
                        style="object-fit: cover;"
                      />
                      <img
                        v-if="subdata.imageURL"
                        :src="subdata.imageURL"
                        style="object-fit: cover;"
                      />
                      <img
                        v-if="!subdata.activeuser[0].img_url && !subdata.imageURL"
                        src="@/assets/images/profile-picture.png"
                        style="object-fit: cover;"
                      />
                    </v-avatar>
                  </v-btn>

                  <!-- Amount Donated -->
                  <span class="subheading text-xs-right">
                    <span class="font-weight-bold">{{ Math.floor(projects.amount * 38 / 100) }}€</span>
                    <span class="pink--text">de {{ projects.amount }}€</span>
                  </span>

                  <!-- Progress Bar -->
                  <v-progress-linear
                    background-color="pink lighten-5"
                    color="pink"
                    height="15"
                    value="38"
                  ></v-progress-linear>

                  <!-- -->
                  <v-layout row wrap justify-space-around align-center>
                    <!-- Ong Name 
                              <v-flex xs12>
                                <div class="subheading grey--text text--darken-2 text-xs-center"> {{ projects.Ong.name }} </div>  
                    </v-flex>-->
                    <!-- Address -->
                    <v-chip label round color="white" text-color="pink">
                      <a
                        class="pink--text"
                        align-center
                        :href="'https://maps.google.com/?q='+projects.address"
                        target="_blank"
                        style="text-decoration:none;"
                      >
                        <v-icon left>place</v-icon>
                      </a>
                      <a
                        class="pink--text"
                        align-center
                        :href="'https://maps.google.com/?q='+projects.address"
                        target="_blank"
                        style="text-decoration:none;"
                      >{{ projects.address }}</a>
                    </v-chip>
                  </v-layout>

                  <!-- Tag
                          <v-chip label color="pink" text-color="white"> 
                            <v-icon left>label</v-icon>{{ projects.ambit }} 
                  </v-chip>-->

                  <!-- ODS -->
                  <v-layout row wrap align-center justify-space-around>
                    <v-flex class="text-xs-center" v-for="od in projects.ods" :key="od">
                      <v-tooltip top :color="odsColor(od)">
                        <template v-slot:activator="{ on }">
                          <v-btn icon v-on="on" @click="ODS(od)">
                            <v-icon :color="odsColor(od)">{{ odsIcon(od) }}</v-icon>
                          </v-btn>
                        </template>
                        <span class="white--text font-weight-bold">{{ odsName(od) }}</span>
                      </v-tooltip>
                    </v-flex>
                  </v-layout>

                  <!-- Info Icons Data -->
                  <v-layout row wrap align-center justify-space-around class="mt-3">
                    <!-- Donated -->
                    <v-flex xs4 class="text-xs-center">
                      <v-layout column fill-height align-center justify-center>
                        <v-icon color="grey darken-2">euro_symbol</v-icon>
                        <p>
                          <span class="pink--text">38%</span>
                          <br />Recaudado
                        </p>
                      </v-layout>
                    </v-flex>
                    <!-- Days Left -->
                    <v-flex xs4 class="text-xs-center">
                      <v-layout column fill-height align-center justify-center>
                        <v-icon color="grey darken-2">date_range</v-icon>
                        <p>
                          <span
                            class="pink--text"
                          >{{ moment().diff(projects.limitDate, 'days') * -1 }} Días</span>
                          <br />Restantes
                        </p>
                      </v-layout>
                    </v-flex>
                    <!-- Beneficiaries -->
                    <v-flex xs4 class="text-xs-center">
                      <v-layout column fill-height align-center justify-center>
                        <v-icon color="grey darken-2">language</v-icon>
                        <p>
                          <span class="pink--text">{{ projects.beneficiaries }}</span>
                          <br />
                          <span v-if="projects.beneficiaries > 1">Beneficiarios</span>
                          <span v-if="projects.beneficiaries <= 1">Beneficiario</span>
                        </p>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-card-text>

                <!-- Donation Button -->
                <v-card-actions>
                  <v-btn round block dark color="pink" class="mr-4 ml-4 mb-2">{{$t('home.donate')}}</v-btn>
                </v-card-actions>
              </v-card>
            </v-flex>
            <!-- Visit Button -->
            <v-flex x12 class="my-3">
              <v-btn block color="white" class="pink--text">{{$t('home.visitProject')}}</v-btn>
            </v-flex>
          </v-layout>
        </v-flex>
        <!-- Content -->
        <v-flex xs10 order-xs3 sm6 order-sm3 md7 lg8 xl9 class="my-3">
          <v-layout row wrap align-center justify-space-around>
            <!-- Description -->
            <v-flex xs12 xl5>
              <h1 class="display-1 mb-3">{{ projects.title }}</h1>
              <p class="body-1 text-xs-justify white-space-pre">{{ projects.subtitle }}</p>
              <p class="body-1 text-xs-justify white-space-pre">{{ projects.description }}</p>
            </v-flex>
            <!-- Chart -->
            <v-flex xs12 xl6>
              <apexchart type="pie" width="100%" :options="chartOptions" :series="series" />
            </v-flex>
          </v-layout>
        </v-flex>
        <!-- Comments -->
        <v-flex xs12 order-xs4 sm5 order-sm4 md4 lg3 xl2 class="my-3">
          <template>
            <!-- 1 -->
            <div>
              <v-card class="mb-3">
                <v-container>
                  <v-layout row wrap align-center justify-space-around>
                    <!-- Avatar -->
                    <v-flex xs4 class="text-xs-center">
                      <v-avatar small>
                        <v-img
                          :src="require('@/assets/images/profile-picture.png')"
                          style="object-fit: cover;"
                        ></v-img>
                      </v-avatar>
                    </v-flex>
                    <!-- Data -->
                    <v-flex xs8>
                      <template>
                        <div class="font-weight-bold">20€</div>
                        <div class="pink--text">Pablo Pérez</div>
                        <div class="grey--text text--darken-2">02/05/2023</div>
                      </template>
                    </v-flex>
                    <!-- Comment -->
                    <v-flex xs11 class="text-xs-justify">
                      <div>¡Buen proyecto! ¡Seguid así!</div>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card>
            </div>
            <!-- 2 -->
            <div>
              <v-card class="mb-3">
                <v-container>
                  <v-layout row wrap align-center justify-space-around>
                    <!-- Avatar -->
                    <v-flex xs4 class="text-xs-center">
                      <v-avatar small>
                        <v-img
                          :src="require('@/assets/images/profile-picture.png')"
                          style="object-fit: cover;"
                        ></v-img>
                      </v-avatar>
                    </v-flex>
                    <!-- Data -->
                    <v-flex xs8>
                      <template>
                        <div class="font-weight-bold">120€</div>
                        <div>
                          <span class="pink--text">Anónimo</span>
                        </div>
                        <div class="grey--text text--darken-2">10/03/2023</div>
                      </template>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card>
            </div>
            <!-- 3 -->
            <div>
              <v-card class="mb-3">
                <v-container>
                  <v-layout row wrap align-center justify-space-around>
                    <!-- Avatar -->
                    <v-flex xs4 class="text-xs-center">
                      <v-avatar small>
                        <v-img
                          :src="require('@/assets/images/profile-picture.png')"
                          style="object-fit: cover;"
                        ></v-img>
                      </v-avatar>
                    </v-flex>
                    <!-- Data -->
                    <v-flex xs8>
                      <template>
                        <div class="font-weight-bold">60€</div>
                        <div>
                          <span class="pink--text">Anónimo</span>
                        </div>
                        <div class="grey--text text--darken-2">28/04/2023</div>
                      </template>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card>
            </div>
            <v-btn block color="white" class="pink--text">Ver más</v-btn>
          </template>
        </v-flex>
        <!-- Pillars -->
        <v-flex xs12 order-xs5 order-sm5 class="my-3">
          <v-layout row wrap :justify-space-around="!screenWidthXS" :justify-start="screenWidthXS">
            <v-flex xs6 sm3 v-for="(pillar, idx) in detail" :key="idx" class="text-xs-center">
              <!-- Title -->
              <p class="body-1">{{ pillar.theme }}</p>
              <!-- Donated Amount -->
              <p
                class="font-weight-bold"
              >{{ Math.floor(pillarDonated[idx] * pillar.amount / 100) }}€ / {{ pillar.amount }}€</p>
              <!-- Dot -->
              <p>
                <span v-if=" 100 * pillarDonated[idx] / pillar.amount >= 100 ">
                  <v-icon color="light-green accent-3">check_circle</v-icon>
                </span>
                <span v-if=" 100 * pillarDonated[idx] / pillar.amount < 100 ">
                  <v-icon>fiber_manual_record</v-icon>
                </span>
              </p>
              <!-- Pillar Progress -->
              <div class="pillar" @click="pillarsModal = true, pillarsDetail = idx + 1">
                <div
                  class="pillar-progress-bar"
                  :style=" {height: Math.floor(pillarDonated[idx]) + '%' }"
                ></div>
              </div>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>

    <!-- Buttons -->
    <v-fab-transition>
      <v-btn
        fixed
        color="pink"
        round
        large
        dark
        @click="editNewProject"
        style="left: 25%;bottom: 5rem;z-index: 10;"
      >Editar</v-btn>
    </v-fab-transition>
    <v-fab-transition>
      <v-btn
        fixed
        color="pink"
        round
        large
        dark
        :loading="loading"
        @click="createNewProject"
        style="right: 25%;bottom: 5rem;z-index: 10;"
      >Crear</v-btn>
    </v-fab-transition>

    <!-- Project Created Modal -->
    <v-dialog v-model="projectCreated" persistent max-width="500px">
      <v-card>
        <v-card-text>
          <v-layout row wrap align-center justify-space-around class="text-xs-center">
            <v-flex xs12>
              <span class="display-1">¡Tu proyecto ha sido creado!</span>
            </v-flex>
            <v-flex xs6>
              <v-img :src="require('@/assets/images/Congratulations.png')"></v-img>
            </v-flex>
            <v-flex xs12 class="text-xs-center">
              <p class="body-2">
                Será revisado por nuestro equipo legal para evitar fraudes
                <br />En
                <span class="pink--text font-weight-bold">24h</span> sera publicado una vez aprobado
              </p>
            </v-flex>
          </v-layout>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn round dark color="pink" class="mb-3" @click="$router.push('/')">Finalizar</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Pillars Modal -->
    <v-dialog v-model="pillarsModal" persistent max-width="800px">
      <v-card>
        <v-window v-model="pillarsDetail">
          <v-window-item v-for="(theme, idx) in detail" :key="idx" :value="idx + 1">
            <!-- Title -->
            <v-card-title primary-title class="ml-3">
              <h2
                :class="{
                  'title': screenWidthXS,
                  'headline': screenWidthSM || screenWidthMD || screenWidthLG || screenWidthXL
                }"
              >{{ theme.theme }}</h2>
              <v-spacer></v-spacer>
              <v-tooltip left color="pink">
                <template v-slot:activator="{ on }">
                  <v-icon
                    class="mr-4 hidden-xs-only"
                    color="pink"
                    style="font-size:5rem;"
                    v-on="on"
                  >insert_drive_file</v-icon>
                </template>
                <span class="white--text font-weight-bold">Facturas</span>
              </v-tooltip>
              <v-btn icon @click="pillarsModal = false">
                <v-icon color="grey">close</v-icon>
              </v-btn>
            </v-card-title>

            <!-- Content -->
            <v-card-text>
              <v-container class="pt-0">
                <v-layout row wrap align-center>
                  <v-flex xs1 hidden-xs-only class="text-xs-left">
                    <v-btn icon @click="pillarsDetail--" v-if="pillarsDetail > 1">
                      <v-icon large>arrow_back</v-icon>
                    </v-btn>
                  </v-flex>
                  <!-- Description -->
                  <v-flex xs12 sm10>
                    <p class="body-1">{{ theme.description }}</p>
                    <v-tooltip left color="pink">
                      <template v-slot:activator="{ on }">
                        <v-icon
                          class="mr-4 hidden-sm-and-up"
                          color="pink"
                          style="font-size:5rem;"
                          v-on="on"
                          @click="window.open(theme.tickets)"
                        >insert_drive_file</v-icon>
                      </template>
                      <span class="white--text font-weight-bold">Facturas</span>
                    </v-tooltip>
                  </v-flex>
                  <v-flex xs1 hidden-xs-only class="text-xs-right">
                    <v-btn icon @click="pillarsDetail++" v-if="pillarsDetail < detail.length">
                      <v-icon large>arrow_forward</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
          </v-window-item>
        </v-window>
      </v-card>
    </v-dialog>
    <!-- ODS Modal -->
    <ods-modal :screen="screen" :odsModal="odsModal" :odsDetail="odsDetail" />
  </div>
</template>

<script>
import { eventBus } from "@/main.js";
import ODSModals from "@/components/modals/ODSModal.vue";
import VueApexCharts from "vue-apexcharts";

export default {
  props: [
    "screen",
    "ods",
    "projects",
    "detail",
    "videoFrame",
    "projectImagesPreview",
    "projectBackgroundPreview",
    "series",
    "chartOptions",
    "projectImagesUpload"
  ],
  components: {
    apexchart: VueApexCharts,
    "ods-modal": ODSModals
  },
  mounted() {
    this.getUser();
  },
  data: () => ({
    loading: false,
    avatar: {
      size: null,
      top: null
    },
    pillarDonated: [100, 35, 75, 15],
    subdata: {
      activeuser: [],
      userinformation: [],
      image: null
    },
    // Project Created Modal
    projectCreated: false,
    // ODS Modal
    odsModal: false,
    odsDetail: 100,
    // Pillar Modal
    pillarsModal: false,
    pillarsDetail: null
  }),
  computed: {
    screenWidthXS() {
      return this.screen.width < 600
        ? ((this.avatar.size = 110), (this.avatar.top = 4), true)
        : ((this.avatar.size = 150), (this.avatar.top = 7), false);
    },
    screenWidthSM() {
      return this.screen.width > 600 && this.screen.width < 960 ? true : false;
    },
    screenWidthMD() {
      return this.screen.width > 960 && this.screen.width < 1264 ? true : false;
    },
    screenWidthLG() {
      return this.screen.width > 1264 && this.screen.width < 1904
        ? true
        : false;
    },
    screenWidthXL() {
      return this.screen.width > 1904 ? true : false;
    }
  },
  methods: {
    createNewProject() {
      this.loading = true;
      var localuser = JSON.parse(localStorage.getItem("userLocalStorage"));
      var body = {};
      body.projects = this.projects;
      body.projects.ong_id = localuser.id;
      body.pillars = this.detail;
      body.images = this.projectImagesUpload;
      ///NOOO BORRARRRR DESCOMENTAR Y APUNTAR A PRO CUANDO LO VAYAMOS A SUBIR
      this.$http.post("/projects", body).then(response => {
        console.log(response)
        if (response.status == 200) {
          this.projectCreated = true;
        }
      });
      //this.projectCreated = true
    },
    editNewProject() {
      eventBus.$emit("projectStep", 1);
    },
    ODS(odsID) {
      var idx = this.ods.findIndex(item => item.id === odsID);
      this.odsModal = true;
      this.odsDetail = idx;
    },
    odsColor(odsID) {
      var idx = this.ods.findIndex(item => item.id === odsID);
      return this.ods[idx].color;
    },
    odsIcon(odsID) {
      var idx = this.ods.findIndex(item => item.id === odsID);
      return this.ods[idx].icon;
    },
    odsName(odsID) {
      var idx = this.ods.findIndex(item => item.id === odsID);
      return this.ods[idx].name;
    },
    getUser() {
      var localuser = JSON.parse(localStorage.getItem("userLocalStorage"));
      if (localuser) {
        this.$http
          .get("/user/" + localuser.id, {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json"
            }
          })
          .then(response => {
            localStorage.setItem("user", JSON.stringify(response.data.user));
            this.subdata.activeuser.push(
              JSON.parse(localStorage.getItem("userLocalStorage"))
            );
          });
      } else {
        this.subdata.activeuser = [];
      }
      if (localuser.type) {
        this.subdata.imageURL = localuser.img_url;
      }
    }
  },
  created() {
    eventBus.$on("odsModalDisplay", display => {
      this.odsModal = display;
    });
    eventBus.$on("odsDetailChange", change => {
      this.odsDetail = change;
    });
    eventBus.$on("odsClicked", idx => {
      this.odsDetail = idx;
    });
    eventBus.$on("odsIconClicked", odsID => {
      var idx = this.ods.findIndex(item => item.id === odsID);
      this.odsDetail = idx;
    });
  }
};
</script>
